/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Button, Checkbox, Classes } from '@blueprintjs/core';
import { PropTypes } from 'prop-types';

export function PropertyCheckBox({ text, onChange, checked, ...rest }) {
	const propertyStyle = css`
		margin-bottom: 0;
	`;

	return (
		<Button className={`${Classes.MINIMAL}`} css={textItemStyles}>
			<Checkbox checked={checked} onChange={onChange} css={propertyStyle} {...rest}>
				{text}
			</Checkbox>
		</Button>
	);
}

PropertyCheckBox.propTypes = {
	text: PropTypes.string,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
};

export const textItemStyles = css`
	justify-content: flex-start;
	padding: 5px 10px 5px 0;

	.bp3-icon.bp3-icon-select:first-of-type {
		margin: 0;
	}
`;
